<template>
  <div @mouseleave="onEnter">
    <div class="tooltip">
      <button
        class="copyHashButton"
        v-clipboard:copy="textToCopy"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        <v-icon name="copy" scale="1.2"></v-icon>
      </button>
      <span class="tooltiptext">{{ toolTipText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    textToCopy: String,
  },
  data() {
    return {
      toolTipText: this.text,
    };
  },
  methods: {
    onCopy: function () {
      this.toolTipText = "Copied!";
    },
    onEnter: function () {
      this.toolTipText = this.text;
    },
    onError: function () {
      this.toolTipText = "Failed!";
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 100px;
  background-color: #48b9ba;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 44px;
  left: 50%;
  margin-left: -50px;
  opacity: 0;
  transition: opacity 0.5s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #48b9ba transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.copyHashButton {
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: white;
  padding: 7px 15px 5px 15px;
  background-color: #48b9ba;
  transition: 0.1s ease-in;
  width: 50px;
  height: 35px;
  min-width: 0;
}
</style>
